import { LogoutOutlined, LoginOutlined, UserOutlined, DownOutlined } from "@ant-design/icons";
import { useDispatch, useSelector} from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, Menu, Avatar, Modal, Tag } from "antd";
import { AppDispatch } from "../../../../redux/root/root.store";
import {
  AuthSliceMethods,
  getAuthState,
} from "../../../../redux/slices/authSlice";
import { EntUser } from "../../../../models/user";
import { useEffect } from "react";
import { RootState } from "../../../../redux/root/root-state.interface"; 

export const LoginSidebar = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { isLoggedIn, secondName, name, roles } = useSelector(getAuthState);



  
  const superAdminRole = roles?.find((role) => role.alias === "SUPER_ADMIN");
  
  const handleDirectLogout = () => {
    dispatch(AuthSliceMethods.logout());
    navigate("/");
  };
  useEffect(() => {
    if (isLoggedIn) {
      
      if (!roles || roles.length === 0) {
        dispatch(AuthSliceMethods.getUserInfo())
          .unwrap()
          .then((response: EntUser) => {
            if (!response.roles || response.roles.length === 0) {
              handleDirectLogout();
            }
          })
          .catch(() => {
            handleDirectLogout();
          });
      }
    }
  }, [isLoggedIn]);

  const displayedRole = superAdminRole
    ? superAdminRole.nameRu || superAdminRole.nameKy
    : roles?.[0]?.nameRu || roles?.[0]?.nameKy || "";

  const handleLogout = () => {
    Modal.confirm({
      title: "Вы уверены, что хотите выйти?",
      content: "После выхода вам нужно будет заново войти в систему.",
      onOk() {
        dispatch(AuthSliceMethods.logout());
        navigate("/");
      },
    });
  };
  const userRoles = useSelector((state: RootState) => getAuthState(state).roles);
  const userRolesArray = userRoles?.map(role => role.alias.trim());
  const hasRequiredRole = (requiredRoles: string[]) => {
    if (!userRolesArray || !requiredRoles) return false;
    return requiredRoles.some(role => userRolesArray.includes(role));
  };

  const hasExcludedRole = (excludedRoles: string[]) => {
    if (!userRolesArray || !excludedRoles) return false;
    return !excludedRoles.some(role => userRolesArray.includes(role));
  };

  const menu = (
    <Menu>
    {hasExcludedRole(['kurultai_ministr']) && (
      <Menu.Item key="admin" icon={<UserOutlined />}>
        <Link to="/main-admin-page">Админ панель</Link>
      </Menu.Item>
      )}
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        style={{ color: "red" }}
        onClick={handleLogout}
      >
        Выйти
      </Menu.Item>
    </Menu>
  );

  const userInitials = `${name?.[0] || ""}${secondName?.[0] || ""}`;
  const fullName = `${name || ""} ${secondName?.[0] || ""}.`;

  return (
    <div>
      {isLoggedIn ? (
        <div>
          <Dropdown
            overlay={menu}
            placement="bottomRight"
            trigger={["click"]}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "8px",
              }}
            >
              <Avatar
                style={{
                  backgroundColor: "#D9D9D9",
                  color: "#000",
                  fontWeight: "500",
                  fontSize: "14px"
                }}
                size={40}
              >
                {userInitials}
              </Avatar>
              <div style={{ 
                marginLeft: "12px",
                display: "flex",
                flexDirection: "column"
              }}>
                <span style={{ 
                  color: "#000",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginBottom: "4px"
                }}>
                  {fullName}
                </span>
                <span style={{ 
                  color: "#848FA1",
                  fontSize: "14px"
                }}>
                  {displayedRole}
                </span>
              </div>
              <DownOutlined 
                style={{ 
                  marginLeft: "8px",
                  color: "#000",
                  fontSize: "12px"
                }} 
              />
            </div>
          </Dropdown>
        </div>
      ) : (
        <div>
          <Link to="/admin-panel/login">
            <LoginOutlined /> Войти
          </Link>
        </div>
      )}
    </div>
  );
};
